import { interfaceError } from '../../i18n/errorMessages';

export function supportErrorMessage(error) {
  const keys = {
    REPORTING_DISABLED: 'disabled',
    INVALID_TEXT: 'text',
    INVALID_IMAGE: 'image',
    IMAGE_TOO_LARGE: 'image',
    UPLOAD_FAILED: 'upload',
    UPLOAD_EXPIRED: 'expiredUpload',
    UPLOAD_UNAVAILABLE: 'upload',
    VERSION_CONFLICT: 'version',
    INVALID_TRANSITION: 'transition',
    REQUEST_CONFLICT: 'request',
    INVALID_CURSOR: 'cursor',
    NOT_FOUND: 'notFound',
  };
  const key = error && keys[error.code];
  return key ? { key: `manage:support.errors.${key}` } : interfaceError(error);
}

export const TYPE_LABELS = { BUG: 'Błąd', FEATURE: 'Nowa funkcja', CHANGE: 'Zmiana' };
export const STATUS_LABELS = { NEW: 'Nowe', IN_ANALYSIS: 'W analizie', PLANNED: 'Zaplanowane', IN_PROGRESS: 'W realizacji', RESOLVED: 'Rozwiązane', REJECTED: 'Odrzucone', CLOSED: 'Zamknięte' };
export function requestId() {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes).map(value => value.toString(16).padStart(2, '0')).join('');
}
